module.exports = __webpack_public_path__ + "img/rope-roof-painting-marriott.bc3d38de.jpg";